/* eslint max-statements: 0 */
import $ from 'jquery';
import _ from 'lodash';
import {beforeMainLoader, completeMainLoader} from './sinclair.ajax';
import thumbTypeDropdownTemplate from '../widgets/templates/thumbTypeDropdown.hbs';
import thumbSelectTemplate from '../widgets/templates/thumbSelect.hbs';
import 'jquery-ui';

export const replaceCloudfrontUrl = function(url) {
    const cacheBuster = Math.floor(Math.random() * 1000000000 + 1);
    let newUrl = '';
    if (url) {
        newUrl = url.replace('http://d3uidndat1pv1d.cloudfront.net/', 'https://s3.amazonaws.com/sinclairstorylinemedia/');
        newUrl = newUrl.split('?');
        newUrl = newUrl[0] + '?' + cacheBuster;
    }
    return newUrl;
};

export const search = {
    searchObj: {
        query: [[]],
        limit: 50,
        offset: 0,
        sortOrders: [
            {
                sortColumn: 'created',
                sortDirection: 'DESC',
            },
        ],
        next: 0,
        prev: 0,
    },
    defaults(opts) {
        this.searchObj.query = [[]];

        this.parent = opts.that;
        //optional load startup query, default is blank for "all"
        this.searchObj.query = opts.query || this.searchObj.query;
        this.searchObj.limit = opts.limit || this.searchObj.limit; //optional set return limit
        this.searchObj.offset = opts.offset || this.searchObj.offset; //optional set offset (starting point)
    },
    buildSearchString(opts) {
        const buildSearchRequest = this.buildSearchRequest(opts);

        return (
            buildSearchRequest.url +
            '&queryParameters=' +
            JSON.stringify(buildSearchRequest.data.searchQueries) +
            '&sortOrders=' +
            JSON.stringify(buildSearchRequest.data.sortFields)
        );
    },
    buildSearchRequest(opts) {
        const that = this;
        const limit = opts.limit || this.searchObj.limit;
        const offset = opts.offset || this.searchObj.offset;
        const contentScope = opts.contentScope ? opts.contentScope : 'all';
        const query = opts.query || $.extend(true, [], this.searchObj.query) || [[]];
        const sortOrders = opts.sort || [
            {
                sortColumn: 'created',
                sortDirection: 'DESC',
            },
        ];

        _.each(query, function(ors) {
            _.each(ors, function(and) {
                const id = and.id;
                delete and.id;
                _.each(that.fields, function(field) {
                    if (field.required && field.name === id) {
                        _.each(field.required, function(criteria) {
                            if (criteria.alias) {
                                and.alias = criteria.alias;
                            }
                            if (criteria.field) {
                                ors.push(criteria);
                            }
                        });
                        return false;
                    }
                });
            });
        });

        return {
            url:
                '/api/rest/facade/' +
                opts.type +
                '/advanced-search?limit=' +
                limit +
                '&offset=' +
                offset +
                '&contentScope=' +
                contentScope,
            data: {
                searchQueries: query,
                sortFields: sortOrders,
            },
        };
    },
    searchHandler() {
        const that = this.parent;
        that._searchHandler();
    },
    searchSuccess(opts) {
        const response = {
            data: opts.data,
            response: opts.response,
        };
        opts.x = opts.x || 1;
        this.searchObj.next = this.searchObj.offset + this.searchObj.limit;
        this.searchObj.prev = this.searchObj.offset - this.searchObj.limit;
        if (this.searchObj.prev < 0) {
            this.searchObj.prev = 0;
            this.searchObj.offset = 0;
            $(opts.prev)
                .parent('li')
                .addClass('disabled');
        } else {
            $(opts.prev)
                .parent('li')
                .removeClass('disabled');
        }

        $(opts.current).html(this.searchObj.offset * opts.x + 1 + ' - ' + this.searchObj.next * opts.x);

        return response;
    },
    addBasicSearchFiltersHandler(opts) {
        const value = opts.value || opts.searchInput.val();

        if (value) {
            const query = [];
            for (const filter in opts.filters) {
                query.push([
                    {
                        //or
                        id: filter,
                        field: opts.filters[filter],
                        operation: 'LIKE',
                        value,
                    },
                ]);
            }
            this.searchObj.query = query;
            $('#sda-advanced-search-clear').remove();
            this.searchHandler();
        }
    },
    addSearchFiltersHandler(opts) {
        let value = opts.value || opts.searchInput.val();
        const valuePM = new Date(value + ' 23:59:59');
        const valueAM = new Date(value + ' 00:00:00');
        const filterFieldVal = opts.default ? 'all' : opts.filterField.attr('data-value');
        const operatorVal = opts.default ? 'LIKE' : opts.operator.attr('data-value');
        const filterFieldDesc = opts.default ? 'any field' : opts.filterField.attr('data-name');
        const operatorDesc = opts.default ? 'contains' : opts.operator.attr('data-name');
        const queryBlock = `<div
            class="sda-query-block"
            data-field="${filterFieldVal}"
            data-operator="${operatorVal}"
            data-value="${value}">
                ${filterFieldDesc} ${operatorDesc}
                <span class="sda-query">${value}</span>
                <a class="sda-remove-search-operator"> <i class="fa-times"></i></a>
            </div>`;
        let query = {
                id: filterFieldDesc,
                field: filterFieldVal,
                operation: operatorVal,
                value,
            },
            filter,
            q;

        opts.searchInput.val('');

        if (value) {
            if (filterFieldVal === 'all') {
                if ($.isEmptyObject(this.searchObj.query[0])) {
                    query = [];
                    for (filter in opts.filters) {
                        query.push([
                            {
                                //or
                                id: filter,
                                field: opts.filters[filter],
                                operation: operatorVal,
                                value,
                            },
                        ]);
                    }
                } else {
                    let newQuery = [];
                    query = this.searchObj.query;

                    for (filter in opts.filters) {
                        newQuery = {
                            id: filter,
                            field: opts.filters[filter],
                            operation: operatorVal,
                            value,
                        };
                        for (q in query) {
                            if (query[q][0].field === opts.filters[filter]) {
                                query[q].push(newQuery);
                            }
                        }
                    }
                }

                this.searchObj.query = query;
                opts.queryContainer.append(queryBlock);
            } else if (
                (filterFieldVal === 'created' ||
                    filterFieldVal === 'publishedDate' ||
                    filterFieldVal === 'lastSavedDate') &&
                operatorVal === 'EQUALS'
            ) {
                //between midnight of the date BEFORE selected date and midnight of the date selected

                const utcValuePM = Date.parse(valuePM); //latest
                const utcValueAM = Date.parse(valueAM); //earliest
                const query1 = {
                    field: filterFieldVal,
                    operation: 'LESSTHAN',
                    value: utcValuePM,
                }; //and
                const query2 = {
                    field: filterFieldVal,
                    operation: 'GREATERTHAN',
                    value: utcValueAM,
                };

                this.searchObj.query[0].push(query1, query2);
                for (q in this.searchObj.query) {
                    this.searchObj.query[q].push(query1, query2);
                }

                opts.queryContainer.append(queryBlock);
            } else if (
                (filterFieldVal === 'created' ||
                    filterFieldVal === 'publishedDate' ||
                    filterFieldVal === 'lastSavedDate') &&
                (operatorVal === 'GREATERTHAN' || operatorVal === 'LESSTHAN')
            ) {
                if (operatorVal === 'GREATERTHAN') {
                    //after midnight of the date selected
                    value = Date.parse(valuePM); //latest
                } else if (operatorVal === 'LESSTHAN') {
                    //before midnight of the date BEFORE date selected
                    value = Date.parse(valueAM); //earliest
                }
                query = {
                    field: filterFieldVal,
                    operation: operatorVal,
                    value,
                };

                this.searchObj.query[0].push(query);

                opts.queryContainer.append(queryBlock);
            } else {
                for (q in this.searchObj.query) {
                    this.searchObj.query[q].push(query);
                }
                opts.queryContainer.append(queryBlock);
            }

            this.searchHandler();
        } else if ((operatorVal === 'ISEMPTY' || operatorVal === 'ISNULL') && !value) {
            query = {
                field: filterFieldVal,
                operation: operatorVal,
            };
            this.searchObj.query[0].push(query);
            opts.queryContainer.append(queryBlock);
            this.searchHandler();
        } else if (filterFieldVal === 'all' && !value) {
            this.searchObj.query = [[]];

            this.searchHandler();
        }
        $('#sda-advanced-search-clear').remove();
        opts.queryContainer.append(
            '<a id="sda-advanced-search-clear" class="sda-btn sda-clear-search-query" >clear all</a>',
        );
    },
    clearSearch(refresh) {
        this.searchObj.offset = 0;
        this.searchObj.query = [[]];
        $('.sda-search-query-container').empty();

        if (refresh) {
            this.searchHandler();
        }
    },
    removeSearchOperatorHandler(e, opts) {
        const $caller = $(e.currentTarget);
        const $parent = $caller.parent();
        const query = this.searchObj.query;
        const data = $parent.data();
        let newQuery = [[]];

        for (let key in query[0]) {
            if (
                data.field === query[0][key].field &&
                data.operator === query[0][key].operation &&
                data.value === query[0][key].value
            ) {
                $parent.remove();
            } else if (
                data.operator === 'EQUALS' &&
                (query[0][key].operation === 'GREATERTHAN' || query[0][key].operation === 'LESSTHAN')
            ) {
                $parent.remove();
            } else if (
                (data.field === 'created' || data.field === 'publishedDate' || data.field === 'lastSavedDate') &&
                data.operator === query[0][key].operation
            ) {
                $parent.remove();
            } else if (data.field === 'all') {
                for (key in query[0]) {
                    for (const q in query[key]) {
                        if (query[key][q].value !== data.value || query[key][q].operation !== data.operator) {
                            newQuery = [];
                            newQuery.push([query[key][q]]);
                        }
                    }
                }

                $parent.remove();
            } else {
                newQuery[0].push(query[0][key]);
            }
        }

        if (opts.$queryContainer.length < 1) {
            opts.$filterButton.removeClass('active');
            opts.$searchButton.addClass('active');
            opts.$searchInput
                .datepicker('destroy')
                .parent()
                .removeClass('show-calendar');
        }
        $('.sda-query-block').each(function() {
            const $this = $(this);
            if (
                $this.data().field === data.field &&
                $this.data().operator === data.operator &&
                $this.text() === $parent.text()
            ) {
                $this.remove();
            }
        });
        if (!$('.sda-query-block').length) {
            $('#sda-advanced-search-clear').remove();
        }

        this.searchObj.query = newQuery;
        this.searchHandler();
    },
    searchSelectorHandler(e, opts) {
        const $caller = $(e.currentTarget);
        const field = $caller.val();
        opts.$filterButton.addClass('active');
        opts.$searchButton.removeClass('active');

        opts.$operator.find('li.select-option').hide();
        const field2 = $('#search-fields').val();
        let _class = null;
        switch (field2) {
            case 'all':
            case 'updatedBy':
            case 'title':
            case 'caption':
                _class = '.non-date';
                break;
            case 'tags':
                _class = '.tags';
                break;
            case 'created':
            case 'publishedDate':
            case 'lastSavedDate':
                _class = '.date';
                break;
            default:
                _class = 'li.select-option';
                break;
        }

        const selects = $(_class);
        selects.show();

        if ($caller.attr('id') !== 'search-operators') {
            $.each($(_class + ':not(.test)'), function(i, item) {
                item = $(item);
                const name = item.attr('data-name');
                const value = item.attr('data-value');
                opts.$operator
                    .find('.sda-select-selected')
                    .attr('data-value', value)
                    .attr('data-name', name)
                    .find('.thumb-name')
                    .html(name);
                return false;
            });
        }

        if (
            opts.$filterField.val() === 'created' ||
            opts.$filterField.val() === 'publishedDate' ||
            opts.$filterField.val() === 'lastSavedDate'
        ) {
            opts.$searchInput
                .datepicker({
                    beforeShow() {
                        $('#ui-datepicker-div').addClass('sda-advanced-search-calendar');
                    },
                })
                .parent()
                .addClass('show-calendar');
            if (field !== 'EQUALS' && field !== 'GREATERTHAN' && field !== 'LESSTHAN') {
                opts.$operator.set('EQUALS');
            }
            $('#sda-calendar-thumb').click(function() {
                if ($('#ui-datepicker-div').css('display') === 'none') {
                    opts.$searchInput.datepicker('show');
                } else {
                    opts.$searchInput.datepicker('hide');
                }
            });
        } else {
            opts.$searchInput
                .datepicker('destroy')
                .parent()
                .removeClass('show-calendar');
        }

        if (field === 'ISEMPTY' || field === 'ISNULL') {
            opts.$searchInput
                .hide()
                .parent()
                .addClass('isempty');
        } else {
            opts.$searchInput
                .show()
                .parent()
                .removeClass('isempty');
        }
    },
    searchIncrementHandler(e) {
        e.originalEvent.preventDefault();
        const $caller = $(e.currentTarget);
        const $parent = $caller.parent('li');
        const action = $caller.attr('href');

        if ($parent.hasClass('disabled')) {
            return false;
        }

        this.searchObj.offset = this.searchObj[action];
        this.searchHandler();
        return false;
    },
    searchExternalId() {},

    video: {
        offset: 0,
        total: 0,
    },
    image: {
        offset: 0,
        total: 0,
    },
    $lastItem: '',
    setLastItem() {
        // ensure the selector works on both the media page and on the gallery page within a story.
        // make sure the selector does not inlcude the items selected from within a story (in the footer)
        this.$lastItem = $('.sda-media-card-list-container li.sda-card-media, .sda-media-library-list > li').last();
    },
    filter: 'all',

    resetLoaderValues() {
        this.video = {
            offset: 0,
            total: 0,
        };
        this.image = {
            offset: 0,
            total: 0,
        };
        this.$lastItem = $('<div />');
        this.filter = 'all';
    },
    // how close to the bottom of the viewport the last item
    // has to be to trigger lazy load
    threshold: 200,
    thresholdMet() {
        const offset = this.$lastItem.offset(); // returns null if doesn't exist
        return offset && offset.top - this.threshold <= window.innerHeight;
    },
    getLazyLoadingFilters() {
        const neededFilters = [];
        const mediaTypes = this.filter === 'all' ? ['image', 'video'] : [this.filter];
        if (this.filter) {
            _.each(
                mediaTypes,
                function(mediaType) {
                    const offset = this[mediaType].offset;
                    if (offset === null || offset < this[mediaType].total) {
                        neededFilters.push(mediaType);
                    }
                },
                this,
            );
        }

        return neededFilters.length === 2 ? 'all' : neededFilters[0]; // might be undefined but that's okay
    },
};

export function mergeCollections(opts, callback) {
    const result = $.Deferred();
    const imageOpts = {type: 'image'};
    const videoOpts = {type: 'video'};
    let dataCollection, limit;
    const holdVideoCollection = opts.childCollection1 ? copyCollectionModels(opts.childCollection1) : [];
    const holdImageCollection = opts.childCollection2 ? copyCollectionModels(opts.childCollection2) : [];
    const holdLibraryCollection = opts.parentCollection ? copyCollectionModels(opts.parentCollection) : [];

    if (!opts.filter) {
        opts.filter = 'all';
    }

    if (opts.render === 'lazyload') {
        imageOpts.offset = search.image.offset;
        videoOpts.offset = search.video.offset;
        limit = opts.filter === 'all' ? 25 : 50;
        imageOpts.limit = limit;
        videoOpts.limit = limit;
    } else {
        search.resetLoaderValues();
        beforeMainLoader();
    }

    if (opts.childCollection1) {
        opts.childCollection1.reset();
    }
    if (opts.childCollection2) {
        opts.childCollection2.reset();
    }
    if (opts.parentCollection) {
        opts.parentCollection.reset();
    }

    const videoUrl = opts.videoUrl || search.buildSearchString(videoOpts);
    const imageUrl = opts.imageUrl || search.buildSearchString(imageOpts);

    if (opts.filter !== 'all') {
        opts.video = {
            url: videoUrl,
            searchCollection: opts.childCollection1,
        };
        opts.image = {
            url: imageUrl,
            searchCollection: opts.childCollection2,
        };
        opts[opts.filter].searchCollection.reset();

        opts.parentCollection.getMedia(opts[opts.filter].url, opts[opts.filter].searchCollection, function() {
            opts.parentCollection.sort();
            dataCollection = opts.parentCollection.clone();
            dataCollection.forEach(function(model) {
                model.siteid = opts.siteid;
                if (model.get('video')) {
                    model.id = model.attributes.video.uuid;
                } else {
                    model.id = model.attributes.image.uuid;
                }
            });

            opts.parentCollection.forEach(function(model) {
                if (model.get('video')) {
                    model.id = model.attributes.video.uuid;
                } else {
                    model.id = model.attributes.image.uuid;
                }
            });
            result.resolve();
            dataCollection.siteid = opts.siteid;
            if (opts.render === 'story') {
                opts.that._renderMediaPanel();
            } else if (opts.render === 'search') {
                $(opts.el)
                    .html(opts.template(dataCollection))
                    .sdaInitWidgets();
            } else if (opts.render === 'lazyload') {
                $(opts.el)
                    .append(opts.template(dataCollection))
                    .sdaInitWidgets();
            }

            search.setLastItem();
            // STOP THE LOADER BECAUSE THE CALLBACK IN TO COMPLETE WILL NOT STOP IT
            completeMainLoader();

            if (typeof callback === 'function') {
                if (opts.childCollection1) {
                    opts.childCollection1.add(holdVideoCollection);
                }

                if (opts.childCollection2) {
                    opts.childCollection2.add(holdImageCollection);
                }

                if (opts.parentCollection) {
                    opts.parentCollection.add(holdLibraryCollection);
                }

                callback();
            }
        });
    } else {
        opts.parentCollection.getMedia(videoUrl, opts.childCollection1, function() {
            opts.parentCollection.getMedia(imageUrl, opts.childCollection2, function() {
                opts.parentCollection.sort();
                result.resolve();
                dataCollection = opts.parentCollection;
                dataCollection.forEach(function(model) {
                    model.siteid = opts.siteid;
                });
                dataCollection.siteid = opts.siteid;

                if (opts.render === 'search') {
                    $(opts.el)
                        .html(opts.template(dataCollection))
                        .sdaInitWidgets();
                } else if (opts.render === 'media') {
                    $(opts.el)
                        .html(opts.template(dataCollection))
                        .sdaInitWidgets();
                    opts.that._searchSuccess();
                } else if (opts.render === 'lazyload') {
                    $(opts.el)
                        .append(opts.template(dataCollection))
                        .sdaInitWidgets();
                }

                search.setLastItem();
                // STOP THE LOADER BECAUSE THE CALLBACK IN TO COMPLETE WILL NOT STOP IT
                completeMainLoader();

                if (typeof callback === 'function') {
                    if (opts.childCollection1) {
                        opts.childCollection1.add(holdVideoCollection);
                    }

                    if (opts.childCollection2) {
                        opts.childCollection2.add(holdImageCollection);
                    }

                    if (opts.parentCollection) {
                        opts.parentCollection.add(holdLibraryCollection);
                    }

                    callback();
                }
            });
        });
    }

    return result;
}

function copyCollectionModels(collection) {
    const temp = [];

    _.each(collection.models, function(m) {
        temp.push(m.clone());
    });

    return temp;
}

export function setUpSearchSelectorDropdown() {
    const $fields = $('#search-fields');
    const $operators = $('#search-operators');
    const $fieldsSelected = $('#search-fields .sda-select-selected');
    const $operatorsSelected = $('#search-operators .sda-select-selected');
    const operatorOpts = {
        list: [
            {
                name: 'contains',
                value: 'LIKE',
                classes: 'non-date tag',
            },
            {
                name: 'is',
                value: 'EQUALS',
                classes: 'date non-date tag',
            },
            {
                name: 'is not',
                value: 'NOTEQUALS',
                classes: 'non-date',
            },
            {
                name: 'is after (date)',
                value: 'GREATERTHAN',
                classes: 'date',
            },
            {
                name: 'is before (date)',
                value: 'LESSTHAN',
                classes: 'date',
            },
        ],
        template: thumbTypeDropdownTemplate,
    };
    const fieldOpts = {
        list: [
            {
                name: 'any field',
                value: 'all',
                classes: 'test',
            },
            {
                name: 'uploader',
                value: 'updatedBy',
                classes: 'test',
            },
            {
                name: 'title',
                value: 'title',
                classes: 'test',
            },
            {
                name: 'caption',
                value: 'caption',
                classes: 'test',
            },
            {
                name: 'upload date',
                value: 'created',
                classes: 'test',
            },
            {
                name: 'tag',
                value: 'tags',
                classes: 'test',
            },
        ],
        template: thumbTypeDropdownTemplate,
    };

    operatorOpts.selected = operatorOpts.list[0];
    fieldOpts.selected = fieldOpts.list[0];

    if (!$fieldsSelected.length) {
        $fields.sdaSelect(fieldOpts);
        $fields
            .find('.sda-select-selected')
            .attr('data-value', fieldOpts.selected.value)
            .attr('data-name', fieldOpts.selected.name);
    }

    if (!$operatorsSelected.length) {
        $operators.sdaSelect(operatorOpts);
        $operators
            .find('.sda-select-selected')
            .attr('data-value', operatorOpts.selected.value)
            .attr('data-name', operatorOpts.selected.name);
    }

    $fields.on('select', function(e, value) {
        const $selected = $(this)
            .data()
            .getSelectedEl();
        $(this)
            .find('.sda-select-selected')
            .attr({
                'data-value': value,
                'data-name': $selected.data().name,
            });
        $('#search-operators').set('LIKE');

        searchSelectorHandler(e, value);
    });

    $operators.on('select', function(e, value) {
        const $selected = $(this)
            .data()
            .getSelectedEl();
        $(this)
            .find('.sda-select-selected')
            .attr({
                'data-value': value,
                'data-name': $selected.data().name,
            });

        searchSelectorHandler(e, value);
    });
}

function searchSelectorHandler(e) {
    const opts = {
        $filterButton: $('.sda-add-filters-btn'),
        $searchButton: $('.sda-search-btn'),
        $searchInput: $('#media-search'),
        $filterField: $('#search-fields'),
        $operator: $('#search-operators'),
    };

    search.searchSelectorHandler(e, opts);
    return false;
}

export function setUpCardSelectorDropdown(el, target) {
    const opts = {
        list: [
            {
                name: 'large',
                value: 'thumbnail-large-view',
                icon: 'fa-square',
            },
            {
                name: 'medium',
                value: 'thumbnail-medium-view',
                icon: 'fa-th-large',
            },
            {
                name: 'small',
                value: 'thumbnail-small-view',
                icon: 'fa-th',
            },
            {
                name: '',
                value: 'divider',
                icon: '',
            },
            {
                name: 'list view',
                value: 'list-view',
                icon: 'fa-bars',
            },
        ],
        mainTemplate: thumbSelectTemplate,
        template: thumbTypeDropdownTemplate,
        iconPos: 'right',
    };

    opts.selected = opts.list[0];
    $(el).sdaBasicSelect(opts);

    $(el).on('select', function() {
        for (const item in opts.list) {
            $(target).removeClass(opts.list[item].value);
        }

        $(target).addClass($(this).val());
    });
}
